const people = [
  {name: "Jan Faracik", username: "janfaracik", color1: "pink", color2: "yellow", angle: 114.186832938992},
  {name: "Tim Jacomb", username: "timja", color1: "purple", color2: "cyan", angle: 45.05438580989023},
  {name: "Catherine Hand", username: "Junius45", color1: "purple", color2: "yellow", angle: 139.07899516440446},
  {name: "David Byrne", username: "flowers", color1: "yellow", color2: "cyan", angle: 67.33983678818281},
  {name: "Luther Little PhD", username: "Priscilla64", color1: "orange", color2: "pink", angle: 270.36209412372784},
  {
    name: "Mercedes Yundt",
    username: "Rolando_Hermiston37",
    color1: "brown",
    color2: "yellow",
    angle: 211.02733177624302
  },
  {name: "Casey Kling PhD", username: "Emely.Lockman", color1: "purple", color2: "pink", angle: 1.3713450905512437},
  {name: "Bobby Wehner", username: "Jaquelin53", color1: "purple", color2: "indigo", angle: 197.20700444802725},
  {name: "Donald Goodwin", username: "Kirsten.Casper", color1: "red", color2: "indigo", angle: 313.5716296384395},
  {name: "Christy O'Hara", username: "Owen93", color1: "orange", color2: "cyan", angle: 154.10958568583283},
  {name: "Alice Cremin", username: "Jace_Dibbert", color1: "red", color2: "blue", angle: 28.892205004701403},
  {name: "Walter Will", username: "Isaac87", color1: "indigo", color2: "purple", angle: 78.78872046090699},
  {name: "Suzanne Schumm", username: "Olga.Raynor", color1: "purple", color2: "indigo", angle: 108.32283842346347},
  {name: "Alonzo Schuster", username: "Nathanael1", color1: "blue", color2: "green", angle: 78.41712658981797},
  {name: "Felix Miller", username: "Damian.Lesch", color1: "yellow", color2: "pink", angle: 350.1743320005561},
  {name: "Emmett Metz", username: "Edison_Trantow", color1: "red", color2: "blue", angle: 323.9027918435706},
  {name: "Barbara Jacobi", username: "Kiarra86", color1: "yellow", color2: "yellow", angle: 205.6790325542168},
  {name: "Lewis Huels Sr.", username: "Ila_Shanahan", color1: "yellow", color2: "indigo", angle: 2.5032106041157576},
  {
    name: "Stacy Wisoky",
    username: "Lorenzo_Bechtelar30",
    color1: "green",
    color2: "orange",
    angle: 230.37262138565762
  },
  {name: "Kimberly Skiles", username: "Santiago.Davis32", color1: "purple", color2: "pink", angle: 64.09940895380232},
  {
    name: "Claudia Kessler",
    username: "Justina_Hettinger44",
    color1: "purple",
    color2: "yellow",
    angle: 234.93451418834726
  },
  {name: "Sophie Koepp", username: "Doris97", color1: "orange", color2: "pink", angle: 266.2572953779668},
  {name: "Matt Berninger", username: "americanmary", color1: "cyan", color2: "brown", angle: 262.9462451007051},
  {
    name: "Jeffery Powlowski",
    username: "Wade_Runolfsdottir",
    color1: "orange",
    color2: "cyan",
    angle: 312.4227636852928
  },
  {name: "Laurie Feeney", username: "Scotty.Wilderman73", color1: "pink", color2: "green", angle: 146.77709086005015},
  {name: "Krista Shields", username: "Bridie11", color1: "pink", color2: "blue", angle: 296.4511381544968},
  {name: "Gordon Marks", username: "Ryley.Welch85", color1: "cyan", color2: "green", angle: 88.88431191456559},
  {name: "Alfredo Johnson", username: "Rhianna_Kozey", color1: "yellow", color2: "indigo", angle: 261.84765685878654},
  {name: "Rosemarie Kulas", username: "Rae_Connelly19", color1: "cyan", color2: "green", angle: 244.33744204870658}
]

export default people;
